import { FunctionComponent } from "react";
import BillingHistoryTable from "rivals/components/shared/User/BillingHistoryTable";

import { setData } from "rivals/shared/utils/qa";
import styles from "./BillingHistory.module.scss";
import strings from "./strings";
import { BillingHistory as Transactions } from "./types";

type Props = Transactions;

const BillingHistory: FunctionComponent<Props> = ({ transactions }) => {
  const { disclaimer, title } = strings;

  const renderBillingHistory = transactions ? (
    <>
      <div className={styles.divider}></div>
      <div className={styles.title} {...setData("billing-history-title")}>
        {title}
      </div>
      <div
        className={styles.disclaimer}
        {...setData("billing-history-disclaimer")}
      >
        {disclaimer}
      </div>
      <BillingHistoryTable transactions={transactions} />
    </>
  ) : null;

  return <div className={styles.container}>{renderBillingHistory}</div>;
};

export default BillingHistory;
